
export enum CookieOption {
    NECESSARY = 'necessary',
    PREFERENCES = 'preferences',
    STATISTICS = 'statistics',
    MARKETING = 'marketing',
}